import React, { useEffect, useState, useRef } from "react";
import "echarts-gl";
import * as echarts from 'echarts';
import LogoiCON from "../../assets/images/logo-icon.svg";
import SwitchBordCard from "../../components/SwitchBordCard";
import SwitchBordCard2 from "../../components/SwitchBordCard2";
import PageHeader from "../../components/PageHeader";
import {getLastSession,getLastUser,getDashboardInfo,setDashboardInfo,getCurrentDeviceSerial, setCurrentDeviceSerial} from '../../Data/SessionData.js';
import { createSession, loginUser, dashboardData } from '../../RestUtil.js';
import {
  sparkleCardData,
} from "../../Data/IoTData";
import {
  chartOption2,
} from "../../Data/DashbordData";
import {
  chartOption1,
} from "../../Data/DemographicData";

export default function Dashboard(props) {

  const { loadingPage } = props;
  const [graphMode, setGraphMode] = useState('Live');    
  const [sessionInfo, setSessionInfo] = useState(null);    
  const [currDeviceSerial, setCurrDeviceSerial] = useState(getCurrentDeviceSerial);
  const [timerId, setTimerId] = useState(0);    
  const [timerList, setTimerList] = useState([]);    
  const [logoutTimer, setLogoutTimer] = useState(0);    
  const [dashData1, setDashData1] = useState(null);    
  const [cardData, setCardData] = useState([]);
  const [buttonsIndoor, setButtonsIndoor] = useState([{title: "SF1",switch: false,},{title: "SF2",switch: false,},{title: "Top Limit",switch: false,},{title: "Bottom Limit",switch: false,}]);
  const [buttonsIndoor2, setButtonsIndoor2] = useState([{title: "Current Floor",switch: false,data:0},{title: "Car Door Status",switch: false}]);
  const [anyActivity, setAnyActivity] = useState(false);    

  useEffect(() => {
    setSessionInfo( getLastSession() );
    if (currDeviceSerial) {
       var dashData2 = getDashboardInfo();
      //  console.log(">>> BE Data from Dashboard", dashData2);
      //  console.log("LUT",dashData2.lastUpdatedDateTime);
       setDashData1( dashData2 );
       window.scrollTo(0, 0);
       loadDataCard();
       setCardData([...sparkleCardData]);
       setupActivityListeners(true);
       setAnyActivity(false);
    }
  }, []);

  useEffect(() => {
    if (timerId <= 0) return;
    console.log("timer item being newly added  = ",timerId);
    timerList.push(timerId);
    console.log("timer List after push = ",timerList);
    if (timerList.length > 1) {
       var itemToDelete = timerList.shift();
       console.log("timer List after shift = ",timerList);
       console.log("timer shifted item = ",itemToDelete);
       if (itemToDelete !== timerId) {
          clearInterval(itemToDelete);
          console.log("Now cleared timer with id ",itemToDelete);
       }
    }
    // console.log("timer Item newly added "+timerId+" being deleted "+itemToDelete);
  }, [timerId]);

  useEffect(() => {
    // console.log("anyActivity is ",anyActivity);
    if (logoutTimer > 0) {
      clearInterval(logoutTimer);
      setLogoutTimer(0);
    }
    if (anyActivity === true) {
      setAnyActivity(false);
    }
    else {
    }
    const intervalId = setInterval(() => {
      checkIfAnyActivity();
    }, (60000 * 10)); // Update every 10 mts
    setLogoutTimer(intervalId);
  }, [anyActivity]);

  const deviceSerialChanged = (newSerial) => {
    console.log("Device Serial changed detected3 in Dashboard",newSerial);
    setCurrentDeviceSerial(newSerial);
    setCurrDeviceSerial(newSerial);
    setTimerToPullBEData(newSerial);
  }

  const checkIfAnyActivity = () => {
    console.log("Dashboard.js checking auto-logoff for every 10 mts, now anyActivity flag is ",anyActivity);
    if (anyActivity === false) {
        setupActivityListeners(false);
        window.location = "login";      
    } 
    else {
      setAnyActivity(false);
    }
  };

  const handleAnyActivity = () => {
    // console.log("Now setting anyActivity as true");
    setAnyActivity(true);
  };

  const setupActivityListeners = (setUnset) => {
    if (setUnset == false) {
      document.removeEventListener('mousemove', handleAnyActivity);
      document.removeEventListener('keydown', handleAnyActivity);
      document.removeEventListener('touchstart', handleAnyActivity);
      document.removeEventListener('scroll', handleAnyActivity);
    }
    else {
      document.addEventListener('mousemove', handleAnyActivity);
      document.addEventListener('keydown', handleAnyActivity);
      document.addEventListener('touchstart', handleAnyActivity);
      document.addEventListener('scroll', handleAnyActivity);
    }
  }

  function setTimerToPullBEData(newSerial) {
    const intervalId = setInterval(() => {
      console.log("Dashboard.js timer-id = "+intervalId,"refreshing every seconds, with serial "+newSerial);
      pullBEData('Live', newSerial);
    }, 3000); // Update every 3 seconds    
    setTimerId(intervalId);
    console.log("Set new timer with id "+intervalId+" and device serial "+newSerial);
  }

  function pullBEData(modeStr, newSerial) {
    var sessionData = getLastSession();
    console.log("now pulling data for mode "+modeStr+" and serial",currDeviceSerial);
    dashboardData(sessionData.id,modeStr,newSerial).then(resp => {
      // console.log("dashboard resp",resp);
      setDashboardInfo(resp);
      var dashData2 = getDashboardInfo();
      console.log("pullBEData for mode "+modeStr, dashData2);
      // console.log("LUT",dashData2.lastUpdatedDateTime);
      setDashData1( dashData2 );  
    })
    .catch(err2 => {
      console.log("dashboard failed",err2);          
    });
  }

  function deleteLastTimer() {
    if (timerList.length > 0) {
        var itemToDelete = timerList.shift();
        console.log("timer List after shift = ",timerList);
        console.log("timer shifted item = ",itemToDelete);
        if (itemToDelete > 0) {
          clearInterval(itemToDelete);
          console.log("Now cleared timer with id ",itemToDelete);
        }
    }
  }

  useEffect(() => {
    if (dashData1 == null) return;
    var temp1 = [...buttonsIndoor];
    temp1[0].switch = (dashData1.sf1Status === "OPEN");
    temp1[1].switch = (dashData1.sf2Status === "OPEN");
    temp1[2].switch = (dashData1.topLimitStatus === "OPEN");
    temp1[3].switch = (dashData1.bottomLimitStatus === "OPEN");  
    setButtonsIndoor(temp1);
    //
    var temp2 = [...buttonsIndoor2];
    temp2[0].data = dashData1.carPosition;
    temp2[1].switch = (dashData1.doorSense === "OPEN");
    setButtonsIndoor2(temp2);
    //
    chartPlace();
  }, [dashData1]);

  useEffect(() => {
    if (graphMode == null) return;
    console.log("Graph Mode is changed to",graphMode);
    if (graphMode === "Live") {
        console.log("Now setting-up timer again");
        setTimerToPullBEData(currDeviceSerial);
    }
    else
    if (graphMode === "Weekly") {
      deleteLastTimer();
      setTimerId(0);
      pullBEData(graphMode, currDeviceSerial);
    }
    else
    if (graphMode === "Days15") {
      deleteLastTimer();
      setTimerId(0);
      pullBEData(graphMode, currDeviceSerial);
    }
    else
    if (graphMode === "Days30") {
      deleteLastTimer();
      setTimerId(0);
      pullBEData(graphMode, currDeviceSerial);
    }
  }, [graphMode]);

  //
  // This code is to show the 1st Graph : Voltage Chart
  // we use chartOption1 for the 1st Graph
  // here in this code we set the XAxis of the graph from what was generated on the BE for the X-Axis  
  // Looks like YAxis is automatically being generated based on the min an max values of the points on the graph
  // This graph needs 3 sets of values and plots the data with LineGraph
  //
  function chartPlace() {
    var chartDom = document.getElementById("m_area_chart");
    var myChart = echarts.init(chartDom);
    var option;
    //
    // 1st Graph - Voltage Graph
    //
    option = chartOption1; // genderOverViewOption;
    // console.log("dashData1 inside chartPlace",dashData1);
    // console.log("dashData1.legendXAxis",dashData1.legendXAxis);
    if (option != null && option.xAxis != null && option.xAxis.length > 0 && dashData1.legendXAxis.length > 0) {
      //  console.log("current xAxis",option.xAxis[0].data);
       option.xAxis[0].data = dashData1.legendXAxis;
       if (option.xAxis.length > 1) {
          option.xAxis[1].data = dashData1.legendXAxis;
       }       
       if (option.xAxis.length > 2) {
          option.xAxis[2].data = dashData1.legendXAxis;
       }       
  }
    if (option != null && option.series != null && option.series.length > 0) {
      //  console.log("current series[0]",option.series[0].data);
       option.series[0].data = dashData1.latestL1;
       if (option.series.length > 1) {
          option.series[1].data = dashData1.latestL2;
       }
       if (option.series.length > 2) {
        option.series[2].data = dashData1.latestL3;
       }
    }
    option && myChart.setOption(option);
    //
    // 2nd Graph - KWH and Amps Graph
    //
    var chartDom2 = document.getElementById("m_area_chart2");
    var myChart2 = echarts.init(chartDom2);
    var option2;
    option2 = chartOption2;
    // console.log("dashData1.kwhXAxis",dashData1.kwhXAxis);
    option2.xAxis[0].data = [];
    // if (option2 != null && option2.xAxis != null && option2.xAxis.length > 0 && dashData1.kwhXAxis.length > 0) {
      if (dashData1 != null && dashData1.kwhXAxis != null && dashData1.kwhXAxis.length > 0) {
          option2.xAxis[0].data = dashData1.kwhXAxis;
      // if (option2.xAxis.length > 1) {
      //    option2.xAxis[1].data = dashData1.kwhXAxis;
      // }       
    }
    // console.log("dashData1.latestKwh",dashData1.latestKwh);
    option2.series[0].data = [];
    if (graphMode !== "Live") {
      if (dashData1 != null && dashData1.latestKwh != null && dashData1.latestKwh.length > 0) {
        option2.series[0].data = dashData1.latestKwh;
      }
    }
    // console.log("dashData1.latestAmps",dashData1.latestAmps);
    option2.series[1].data = [];
    if (dashData1 != null && dashData1.latestAmps != null && dashData1.latestAmps.length > 0) {
      option2.series[1].data = dashData1.latestAmps;
    }
    option2 && myChart2.setOption(option2);
  }

  function loadDataCard() {
    var allCardData = cardData;
    cardData.map((data, i) => {
      var uData = [];
      data.sparklineData.data.map((d, j) => {
        return uData[j] = Math.floor(Math.random() * 10) + 1;
      });
      return allCardData[i].sparklineData.data = [...uData];
    });
    setCardData([...allCardData]);
  }

    function handleGraphModeChange(newMode) {
      setGraphMode(newMode);
    }
        
    if (loadingPage) {
      return (
        <div className="page-loader-wrapper">
          <div className="loader">
            <div className="m-t-30">
              <img src={LogoiCON} width="48" height="48" alt="Lucid" />
            </div>
            <p>Please wait...</p>
          </div>
        </div>
      );
    }
    return (
      <div
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            {dashData1 && 
            <PageHeader
              HeaderText="REMS Dashboard"
              Breadcrumb={[{ name: "Dashboard" }]}
              LastUpdatedDate={dashData1.lastUpdatedDateTime} 
              deviceSerial={currDeviceSerial}
              callback={deviceSerialChanged}
            />
            }
            <div className="row clearfix">
              <div className="col-lg-6 col-md-12">                
                <div className="card">
                  <div className="header d-flex justify-content-between">
                    <h2>Voltage Chart (L1,L2,L3)</h2>
                    <div style={{display:"flex",gap:"10px"}}>
                      <button className={`btn ${graphMode === "Live" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Live')} type="button">Live</button>
                      <button className={`btn ${graphMode === "Weekly" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Weekly')} type="button">Weekly</button>
                      <button className={`btn ${graphMode === "Days15" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Days15')} type="button">15-Days</button>
                      <button className={`btn ${graphMode === "Days30" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Days30')} type="button">Monthly</button>
                    </div>
                  </div>
                  <div className="body gender-overview" id="refreshDash1">
                    <h5>
                      <span className="m-r-50">
                        <strong style={{color:"blue"}}>L1</strong> - 
                        {dashData1 && dashData1.currentL1 !== -1 ? dashData1.currentL1 : " no data"}
                      </span>
                      <span className="m-r-50">
                        <strong style={{color:"red"}}>L2</strong> - 
                        {dashData1 && dashData1.currentL2 !== -1 ? dashData1.currentL2 : " no data"}
                      </span>
                      <span className="m-r-50">
                        <strong style={{color:"#FFA500"}}>L3</strong> - 
                        {dashData1 && dashData1.currentL3 !== -1 ? dashData1.currentL3 : " no data"}
                      </span>
                    </h5>
                    <div id="m_area_chart" style={{ height: 300 }}></div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12">   
                <div className="card">
                <div className="header d-flex justify-content-between">
                    <h2>Average mA vs KWh Graph</h2>                    
                    <div style={{display:"flex",gap:"10px"}}>&nbsp;
                    </div>
                  </div>
                  <div className="body gender-overview">
                  <h5>
                      <span className="m-r-50">&nbsp;
                        <strong style={{color:"#5470C6"}}>KWh</strong> - 
                        {dashData1 && dashData1.currentKwh !== -1 ? dashData1.currentKwh : " no data"}
                      </span>
                      <span className="m-r-50">&nbsp;
                      </span>
                      <span className="m-r-50">&nbsp;
                      </span>
                    </h5>
                    <div className="body" id="m_area_chart2" style={{ height: 310 }}></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row clearfix">
              {dashData1 && dashData1.lastUpdatedDateTime !== 'NA'&& 
              <SwitchBordCard2
                Buttons={buttonsIndoor}
                Buttons2={buttonsIndoor2}
                heading="Elevator Status"
              />
              }
            </div>
            
          </div>
        </div>
      </div>
    );
  }
